import { action } from 'satcheljs';

/**
 * Action to set if the user is a first time user.
 */
const setFirstTimeUser = action('setFirstTimeUser', (firstTimeUser: boolean) => ({
    firstTimeUser,
}));

export default setFirstTimeUser;
